export const getOrgCode = () => {
  return window.location.host.split('.').length > 2
    ? window.location.host.split('.')[0]
    : window.location.host.split('.')[1]?.includes('localhost')
      ? window.location.host.split('.')[0]
      : 'default';
};

export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    const context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
};

export const loadScript = (src, position, id) => {
  return new Promise((resolve) => {
    if (!position) {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('id', id);
    script.onload = () => resolve();
    script.src = src;
    position.appendChild(script);
  });
};

export function sanitizeHtml(html) {
  const template = document.createElement('template');
  template.innerHTML = html;

  const scripts = template.content.querySelectorAll('script');
  scripts.forEach((script) => script.remove());

  const elements = template.content.querySelectorAll('*');
  elements.forEach((el) => {
    [...el.attributes].forEach((attr) => {
      if (attr.name.startsWith('on') || attr.value.toLowerCase().includes('javascript:')) {
        el.removeAttribute(attr.name);
      }
    });
  });

  return template.innerHTML;
}

export const slugify = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-');
};

export const formatAvailability = (timestamp) => {
  if (!timestamp || timestamp === Infinity) return null;
  const date = new Date(timestamp);
  return date.toLocaleString('default', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};
